import { format } from "date-fns";
import { Link } from "react-router-dom";
import { Status } from "../Status/Status";
import { BoardCardIcons } from "./BoardCardIcons";
import { ShipmentBoardFooterMeta } from "./ShipmentBoardFooterMeta";
import { PurchaseOrderShipmentSubStatus } from "../../../../purchaseOrder/components/PurchaseOrderShipmentSubStatus";
import { resolveBoardCardFooterLabel, resolveBoardCardHeroText } from "./boardCardDisplay";

const formatEta = value => {
  if (!value) {
    return "Pending";
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "Pending";
  }
  return format(parsed, "dd MMM yyyy, hh:mm a");
};

/**
 * Kanban card for purchase orders on status and milestone boards.
 */
export function PurchaseOrderBoardCard({
  order,
  orderType,
  boardCardHero,
  draggable,
  onDragStart,
  onOpenFiles,
  onOpenNotes,
  onOpenGraph,
}) {
  const heroTitle = resolveBoardCardHeroText(order, orderType, boardCardHero);
  const detailPath =
    orderType === "purchase" ? `/orders/purchase/${order.id}` : `${order.id}`;

  return (
    <div
      className="boardTile shipmentBoardTile"
      draggable={draggable}
      onDragStart={onDragStart}
    >
      <div className="tileHeader">
        <div className="left">
          <input
            className="checkBox"
            draggable={false}
            type="checkbox"
            value={JSON.stringify(order)}
          />
          <Link draggable={false} to={detailPath}>
            {heroTitle}
          </Link>
        </div>
        <BoardCardIcons
          order={order}
          onOpenFiles={onOpenFiles}
          onOpenNotes={onOpenNotes}
          onOpenGraph={onOpenGraph}
        />
      </div>
      <div className="facilityAndAsn">
        <div className="destinationFacility">
          <span>Supplier</span>
          <strong>{order.supplier || "—"}</strong>
        </div>
        <div className="shipmentDetails">
          <div>
            <span>Facility</span>
            <strong>{order.warehouse || "—"}</strong>
          </div>
        </div>
      </div>
      <div className="tileFooter">
        <ShipmentBoardFooterMeta
          orderId={order.id}
          linkTo={detailPath}
          reference={resolveBoardCardFooterLabel(order, orderType, boardCardHero)}
          etaDisplay={formatEta(order.estimated_date || order.eta)}
        />
        <div className="trackerActions">
          <div className="statusAndPriority">
            {orderType === "purchase" ? (
              <PurchaseOrderShipmentSubStatus order={order} />
            ) : (
              <Status statusName={order.status} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
